const isOverflowed = (element)=>element.clientWidth < element.scrollWidth;
const makeOverflowObserver = (onOverflowChange)=>'ResizeObserver' in window ? new ResizeObserver((entries)=>requestAnimationFrame(()=>entries.forEach((entry)=>onOverflowChange(isOverflowed(entry.target))))) : undefined;
export const makeOverflowWatcher = (onOverflowChange)=>{
    let observer;
    let watched = null;
    return {
        watch: (element)=>{
            if (watched === element) return;
            if (watched) observer === null || observer === void 0 ? void 0 : observer.unobserve(watched);
            watched = element;
            if (element) {
                observer = observer !== null && observer !== void 0 ? observer : makeOverflowObserver(onOverflowChange);
                observer === null || observer === void 0 ? void 0 : observer.observe(element);
            }
        },
        disconnect: ()=>observer === null || observer === void 0 ? void 0 : observer.disconnect()
    };
};
export const applyForwardedRef = (ref, element)=>{
    if (typeof ref === 'function') ref(element);
    else if (ref) ref.current = element;
};
